import React from "react";
import "../supplierAndManufacturers.scss";
import ViewHeader from "./ViewHeader";
import ViewBody from "./ViewBody";

const ViewData = {
  name: 'HP',
  icon: '/images/settings-v2/logo.svg',
  isSupplier: true,
  isManufacturer: true,
  categoryName: 'Hardware',
  categoryColor: '#5244B3',
  subcategoryName: 'Laptop',
  subcategoryColor: '#5244B3',
  contact: 'hp@hp.com',
  activationDate: '23 Jun 2020'
}

const ViewModalBody = ({
  data = {},
  isForClient = false,
  itemId = 0,
  changeStatus = () => { },
  clientId = 0,
}) => {
  console.log('data', data)
  return (
    <>
      <ViewHeader
        icon={data?.Logo}
        name={data?.Name}
        description={`${data?.IsSupplier ? 'Supplier' : ''}${(data?.IsSupplier && data?.IsManufacturer) ? ' and ' : ''}${data?.IsManufacturer ? 'Manufacturer' : ''}`}
        categoriesSelectedList={data?.CategorySelected_List}
        subCategoriesSelectedList={data?.SubCategorySelected_List}
        contact={data?.ContactEmail}
        activationDate={data?.ActivationDate}
        website={data?.Website}
        isActive={data?.IsActive}
        changeStatus={changeStatus}
      />

      <ViewBody isForClient={isForClient} data={data} itemId={itemId} isSupplier={data?.IsSupplier} clientId={clientId} />
    </>
  );
};

export default ViewModalBody;
